
import { computed, defineComponent, PropType } from 'vue'
import { useEmployeeModule } from '@/modules/employees'
import { useFormModule } from '@/modules/_shared/forms'

export default defineComponent({
    name: 'employee-form-field-roles',
    emits: ['update:modelValue'],
    props: {
        modelValue: {
            type: Array as PropType<string[]>
        }
    },
    setup () {
        const { validations: { requiredOptionGroupRule } } = useFormModule()
        const { availableRoles } = useEmployeeModule()

        return {
            requiredOptionGroupRule,
            availableRoles: computed(() => availableRoles.value.map(el => ({
                label: el.name,
                value: el.key
            })))
        }
    }
})
